import { BaseMapper } from '@ps/utils';

import { Currency } from '../../models/currency.model';
import { CurrencyDto } from '../dtos/currency.dto';

export class CurrencyMapper extends BaseMapper<CurrencyDto, Currency> {
  public fromDto(dto: CurrencyDto): Currency {
    return {
      crRate: dto.CRRate,
      currencyFullName: dto.currencyFullName,
      currencyShortCode: dto.currencyShortCode,
      fx: dto.fx,
      rate: dto.rate,
      symbol: dto.symbol,
    };
  }
}
